// removed by extract-text-webpack-plugin
module.exports = {"waterWave":"antd-pro_-_-scaffold-src-components-Charts-WaterWave-waterWave","text":"antd-pro_-_-scaffold-src-components-Charts-WaterWave-text"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/WaterWave/index.less
// module id = 431
// module chunks = 0 1